import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { GlobalContext, globalOnDemandVars } from '../../../../../helper/context'
import { uniqueId } from 'lodash'
import InsertFormBaseAddOn from '../insertFormBase'
import { BoxClass } from '../../../../../helper/classes'
import { InsertItem } from '../type1Class'
import { InsertFormArray } from './insertFormRegister'

export const InsertFormBoxClassArray = !InsertFormArray ? [] : InsertFormArray.map((ForInsertForm, index) => {
  const AddonComp = ({ forDialog }) => {
    const getCount = globalOnDemandVars[`CountFor${ForInsertForm.type}`]
    const contextValue = useContext(GlobalContext)

    const refForMini = useRef(null)
    const refForDialog = useRef(null)
    // const currentForMini = refForMini.current
    // const currentForDialog = refForDialog.current

    const [contentData, setContentData] = useState(null)
    const EditorMini = useMemo(() => (
      <ForInsertForm.EditorMini contentData={contentData} setContentData={setContentData} ref={refForMini} />), [contentData])
    const EditorForDialog = useMemo(() => (!forDialog ? null : (ForInsertForm.EditorBig ? (
      <ForInsertForm.EditorBig contentData={contentData} setContentData={setContentData} ref={refForDialog} />
    ) : EditorMini)), [EditorMini, contentData, forDialog])

    // const EditorMini = <ForInsertForm.EditorMini contentData={contentData} setContentData={setContentData} ref={refForMini} />
    // const EditorForDialog = !forDialog ? null : (ForInsertForm.EditorBig ? (
    //   <ForInsertForm.EditorBig contentData={contentData} setContentData={setContentData} ref={refForDialog} />
    // ) : EditorMini)

    const contextValueElement = contextValue[`itemsFor${ForInsertForm.type}`]

    const getCurrentContentData = useCallback(
      () => {
        const count = getCount()
        globalOnDemandVars[`set_CountFor${ForInsertForm.type}`](count + 1)
        // -----------------------------------------------------------------------------------------------------------
        const getCurrentContentData = !forDialog ? (refForMini.current ? refForMini.current.getCurrentContentData : null) : (refForDialog.current ? refForDialog.current.getCurrentContentData : null)
        // 여기서 contentData와 getCurrentContentData() 로 얻는 값의 type이 다를 수 있다는거
        const currentContentData = getCurrentContentData ? getCurrentContentData() : contentData
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'getCurrentContentData',
            value: {
              current: refForMini.current,
              currentContentData
            }
          // , important: true
          })
        }
        // -----------------------------------------------------------------------------------------------------------
        return (new InsertItem(ForInsertForm.type, ForInsertForm.type + '-' + count, currentContentData || null, count, null, ForInsertForm.type + count))
      }
      ,
      [contentData, forDialog, getCount]
    )

    const getCurrentMultiContentData = useCallback(
      () => {
        const getCurrentMultiContentData = !forDialog ? (refForMini.current ? refForMini.current.getCurrentMultiContentData : null) : (refForDialog.current ? refForDialog.current.getCurrentMultiContentData : null)
        const multiContentData = getCurrentMultiContentData()
        return (multiContentData.map((content) => {
          const count = getCount()
          globalOnDemandVars[`set_CountFor${ForInsertForm.type}`](count + 1)
          return (new InsertItem(ForInsertForm.type, content.name || (ForInsertForm.type + '-' + count), content || null, count, null, ForInsertForm.type + count))
        }))
      },
      [forDialog, getCount]
    )

    const clearCurrentContent = useCallback(
      () => {
        setContentData(null)

        const clearCurrentEditor = !forDialog ? refForMini.current.clearCurrentEditor : refForDialog.current.clearCurrentEditor
        if (clearCurrentEditor) {
          if (process.env.NODE_ENV !== 'production') {
            console.tron.display({
              name: 'clearCurrentEditor',
              value: {
                current: refForMini.current,
                clearCurrentEditor
              }
            // , important: true
            })
          }
          try { clearCurrentEditor() } catch (e) {
            if (process.env.NODE_ENV !== 'production') {
              console.tron.display({
                name: 'clearCurrentEditor Error',
                value: {
                  current: refForMini.current,
                  e
                },
                important: true
              })
            }
            throw (e)
          }
        }
      },
      [forDialog]
    )
    return (
      <InsertFormBaseAddOn
        forDialog={forDialog}
        ClassForType={ForInsertForm}
        items={contextValueElement}
        setItems={globalOnDemandVars[`set_itemsFor${ForInsertForm.type}`]}
        EditorMini={EditorMini}
        EditorForDialog={EditorForDialog}
        getCurrentContentData={getCurrentContentData}
        getCurrentMultiContentData={(ForInsertForm.config && ForInsertForm.config.multi) ? getCurrentMultiContentData : false}
        clearCurrentContent={clearCurrentContent}
      />)
  }

  return (
    new BoxClass(AddonComp, `${ForInsertForm.type}`, null, 2, { hasCustomDialogComponent: true, order: index + 2, initialHeight: 480, dialogType: 'bigger' })
  )
})
